import { useUrlStateSlice } from "@/common/hooks/use-url-state-slice";
import { useCallback } from "react";

export function useUrlEnumState<T extends string>(
  sliceKey: string,
  allowedValues: readonly T[],
  defaultValue: T,
): [T, (value: T) => void] {
  const [rawValue, setSlice] = useUrlStateSlice<T>(sliceKey);
  const value = rawValue !== undefined && allowedValues.includes(rawValue) ? rawValue : defaultValue;

  const setValue = useCallback(
    (next: T) => {
      setSlice(next === defaultValue ? undefined : next);
    },
    [setSlice, defaultValue],
  );

  return [value, setValue];
}
